import { Form } from 'antd'
import React, { useEffect, useMemo, useRef } from 'react'
import Chart from 'chart.js/auto'
import { COLORS } from 'app/codes'
import { isNaN, toNumber } from 'lodash'

const SOFPlot = ({ name }) => {
  const chart = useRef()
  const chartCanvas = useRef()

  const data = Form.useWatch(name)

  const chartOptions = useMemo(
    () => {
      if (!data) return {}
      const labels = data.map(row => row.SO)

      const pcDatasetData = data.map(row => toNumber(row.PSIA))
      
      const datasets = []
      datasets.push({
        label: 'Krow',
        data: data.map(row => row.KRO),
        fill: false,
        borderColor: COLORS[1],
        yAxisID: 'KROW',
        tension: 0.4
      })
      datasets.push({
          label: 'Krog',
            data: data.map(row => row.KRG),
            fill: false,
            borderColor: COLORS[0],
            yAxisID: "KROG",
            tension: 0.4
      })
      return {
        labels,
        datasets
      }
    },
    [data])

  const updateChart = (config) => {
    if (!chartCanvas.current) return
    if (!chart.current) return

    if (config.labels) chart.current.data.labels = config.labels
    if (config.datasets) chart.current.data.datasets = config.datasets

    chart.current.update()
  }

  useEffect(() => {
    if (chart.current) chart.current.destroy()
    chart.current = new Chart(chartCanvas.current, {
      type: 'line',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'SOF (Oil Saturation Functions)'
          }
        },
        scales: {
          KROW: {
            type: 'linear',
            display: true,
            position: 'left',
            title: {
              display: true,
              text: 'Krow'
            }
          },
          KROG:{
            type: 'linear',
            display: true,
            position: 'right',
            title: {
              display: true,
              text: 'Krog'
            }
          },
          x: {
            display: true,
            title: {
              display: true,
              text: 'So'
            }
          }
        }
      }
    })
  }, [])

  useEffect(() => {
    updateChart(chartOptions)
  }, [chartOptions])

  return (
    <canvas ref={chartCanvas} />
  )
}

export default SOFPlot 